
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonMatchCategory} from "@/models/app/common/match-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import PlayerNavigationVue from "@/components/player/navigation.vue";
import AppPlayerMatchesRootFilterIndexVue from "@/views/app/player/matches/root/filter/index.vue";
import AppPlayerMatchesRootListIndexVue from "@/views/app/player/matches/root/list/index.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    PlayerNavigationVue,
    AppPlayerMatchesRootFilterIndexVue,
    AppPlayerMatchesRootListIndexVue,
  },
})
export default class AppPlayerMatchesRootIndexVue extends Vue {
  isLoading: boolean | null = false;

  matchCategories: Array<AppCommonMatchCategory> = [];

  $refs!: {
    AppPlayerMatchesRootListIndexVue: any;
  };

  getMatchesByFilter(formData: any): void {
    this.$refs.AppPlayerMatchesRootListIndexVue.getMatches(formData);
  }

  async getMatchCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/match-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.matchCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getMatchCategories();
  }
}
